export var AuthErrorKeys;
(function (AuthErrorKeys) {
    // Wut ?
    AuthErrorKeys["STATE_INVALID"] = "`state` does not match.";
    // Extranet stuff
    AuthErrorKeys["COOPERATIVE_NOT_FOUND_ERROR"] = "ssoNotActivatedForThisCooperative";
    AuthErrorKeys["MEMBERSHIP_NOT_FOUND_ERROR"] = "unknownMembershipNumber";
    AuthErrorKeys["NO_PROFILE_FOUND_ERROR"] = "noUserFoundForThisMembershipNumber";
    AuthErrorKeys["TOO_MANY_PROFILES_FOUND_ERROR"] = "moreThanOneUserForThisMembershipNumber";
    AuthErrorKeys["EXTRANET_AUTHENTICATION_FAILED"] = "notAuthenticatedInPartnerExtranet";
    AuthErrorKeys["WEB_ACCESS_RESTRICTED"] = "web_access_restricted";
    // Auth0
    AuthErrorKeys["ACCESS_DENIED"] = "access_denied";
    // Auth0 lib
    AuthErrorKeys["INVALID_SCOPE"] = "invalidScope";
    AuthErrorKeys["IS_NOT_AUTHENTICATED"] = "isNotAuthenticated";
})(AuthErrorKeys || (AuthErrorKeys = {}));
//# sourceMappingURL=AuthErrorKeys.js.map